import { ReactNode } from 'react'
import { motion } from 'framer-motion'
import Header from '../Header'
import { useTheme } from '../../contexts/ThemeContext'

interface AuthLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
}

export default function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  const { theme } = useTheme()

  return (
    <main className={`min-h-screen ${theme === 'dark' ? 'bg-black' : 'bg-gray-50'}`}>
      <Header />
      
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-md">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h1 className={`text-4xl font-bold mb-4 ${theme === 'dark' ? 'text-gradient' : 'text-gold-500'}`}>
              {title}
            </h1>
            <div className={`w-24 h-1 mx-auto ${theme === 'dark' ? 'bg-gold-500' : 'bg-gold-400'}`}></div>
            {subtitle && (
              <p className={`mt-4 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                {subtitle}
              </p>
            )}
          </motion.div>

          {/* Form Container */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className={`rounded-lg p-8 border-2 ${
              theme === 'dark' 
                ? 'bg-gradient-to-br from-gold-900/30 to-gold-800/20 border-gold-500' 
                : 'bg-white border-gold-400 shadow-lg'
            }`}
          >
            {children}
          </motion.div>
        </div>
      </section>
    </main>
  )
}

